<template>
    <div v-if="!cookieAccepted" class="cookie">
        <div class="cookie__content">
            <div class="cookie__text">
                Мы используем файлы cookie для улучшения вашего опыта на сайте. Подробнее об этом можно узнать в 
                <a href="https://bericar-prd-back.bericar.com/api/files/politika-v-otnoshenii-obrabotki-personalnyh-dannyh" target="_blank" rel="noopener noreferrer">Политике об обработке персональных данных</a>
            </div>
            <button class="button" @click="acceptCookie">Принять и закрыть</button>
        </div>
    </div>
</template>

<script setup lang="ts">

const cookieAccepted = ref(true);

const acceptCookie = () => {
    cookieAccepted.value = true;
    sessionStorage?.setItem('cookie_accepted', 'true');
}

onMounted(() => {
    cookieAccepted.value = !!sessionStorage?.getItem('cookie_accepted') || false;
});

</script>

<style scoped>
.cookie {
    position: fixed;
    align-items: center;
    bottom: 24px;
    right: 36px;
    width: calc(100% - 282px - 36px - 30px - 30px - 4px);
    z-index: 9999;
    padding: 16px 32px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    @media (max-width: 1199px){
        right: 30px;
        width: calc(100% - 30px - 30px);
    }

    @media (max-width: 575px){
        right: 15px;
        width: calc(100% - 15px - 15px);
        padding: 16px 15px;
    }
}

.cookie__text {
    color: #4B4B4B;
}

.cookie__content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1199px){
        flex-direction: column;
    }
}

.cookie__content a {
    color: #FC6337;
    text-decoration: underline;
    
}
.cookie__content a:hover {
    text-decoration: none;
}
.cookie__content button {
    white-space: nowrap;
    margin-left: 16px;
    @media (max-width: 1199px){
        margin-left: 0;
        margin-top: 16px;
    }
}
</style>